import { Controller } from "@hotwired/stimulus";
import { selectOptionFor } from "../utils/inputs_utils";

export default class extends Controller {
  connect() {
    selectOptionFor(this.element, this.element.dataset.preselectedOption);
  }
}
